<button
  mat-icon-button
  matIconSuffix
  type="button"
  matTooltip="Filter by Tag"
  [matMenuTriggerFor]="tagMenu"
  [disabled]="disabled()"
  (click)="$event.stopPropagation()"
>
  <mat-icon
    matBadgeSize="small"
    matBadgeColor="warn"
    [matBadge]="selectedFiltersCount()"
    [matBadgeHidden]="!selectedFilters().length"
    [color]="selectedFilters().length ? 'primary' : undefined"
  >
    filter_list
  </mat-icon>
</button>

<mat-menu #tagMenu="matMenu">
  <div
    class="sticky top-0 z-10 flex items-center gap-2 border-b bg-white px-4 py-2 outline-none"
    (click)="$event.stopPropagation()"
    (keydown)="$event.stopPropagation()"
  >
    <input
      autofocus
      class="w-full bg-transparent text-sm outline-none placeholder:text-gray-400"
      placeholder="Search tags..."
      [formControl]="tagSearchCtrl"
    />
    @if (showClearButton()) {
      <button
        mat-icon-button
        type="button"
        matTooltip="Clear Filters"
        (click)="clearTags()"
      >
        <mat-icon class="text-base">clear</mat-icon>
      </button>
    }
  </div>

  <mat-selection-list
    #selectionList
    [compareWith]="compareWith"
    (selectionChange)="onSelectionChange()"
    (click)="$event.stopPropagation()"
  >
    @for (tag of search.results$ | async; track tag.ref.path) {
      <mat-list-option checkboxPosition="before" [value]="tag">
        <mat-chip
          disableRipple
          [style.--mdc-chip-label-text-color]="tag | tagTextColour"
          [style.background-color]="tag.hexColour"
        >
          {{ tag.name }}
        </mat-chip>
      </mat-list-option>
    } @empty {
      <mat-list-option disabled>
        <div class="px-4 py-2 text-sm text-gray-500">
          No tags found for "{{ tagSearchCtrl.value }}"
        </div>
      </mat-list-option>
    }
  </mat-selection-list>

</mat-menu>
